import styled from 'styled-components';

import { ModalWithTwoFa } from '../modal-with-two-fa/ModalWithTwoFa';

import ResultFeedback from '../result-feedback/ResultFeedback';

export const CustomModalWithTwoFa = styled(ModalWithTwoFa)`
  padding: 2rem;

  ${({ theme }) => theme.media.tablet`
    padding: 3.7rem;
  `};
`;

export const CustomResultFeedback = styled(ResultFeedback)`
  ${({ theme }) => theme.media.tablet`
    min-width: 40rem;
  `};
`;
